<template>
  <BreadCrumb PageTitle="Historique" />
  <HistoryClaim :userId="userId" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import HistoryClaim from "../../components/Claims/HistoryClaim.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "HistoryClaimPage",
  components: {
    BreadCrumb,
    HistoryClaim,
  },

   setup: () => {
    const route = useRoute();
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }


    return { userId };
  }
});
</script>